<template>
  <div class="list-box">
    <div class="nav gap-x-3" title="KeHuList" data-title="基本信息"></div>
    <div
      class="content c-table-box mt-2 bg-white rounded-lg p-4 flex flex-col gap-y-3"
    >
      <ul class="flex gap-x-5">
        <strong>{{ props.model?.name }}</strong>
        <text>{{ props.model?.number }}</text>
        <c_cell
          title="协议期"
          :value="
            props.model?.contract_time + ' ~ ' + props.model?.contract_time_end
          "
        />
        <c_cell title="组织机构代码" :value="props.model?.organization_code" />
        <c_cell title="地址" :value="props.model?.address" class="flex-1" />
        <el-button type="primary" plain link @click="state.showEdit = true">
          <template #icon>
            <el-icon :size="22" class="font-bold">
              <Edit />
            </el-icon>
          </template>
        </el-button>
      </ul>
      <ul class="flex gap-x-5">
        <c_cell title="联系人">
          <template #default>
            <ul class="flex gap-x-2">
              <text>{{ props.model?.contact_name }}</text>
              <c_sex
                :value="props.model?.contact_title == '先生' ? '男' : '女'"
              />
              <text>{{ $phoneFormat(props.model?.contact_phone) }}</text>
            </ul>
          </template>
        </c_cell>
      </ul>
      <c_cell title="负责人">
        <template #default>
          <text>{{ props.model?.lxr }}</text>
          <text>{{ $phoneFormat(props.model.contact_phone) }}</text>
        </template>
      </c_cell>
      <c_cell title="备注" :value="props.model?.remark" />
      <div class="flex items-center text-gray-400 text-xs gap-x-2">
        <text class="text-sm text-gray-600">
          {{ props.model?.belonger_name }}
        </text>
        <text>{{ props.model?.belonger_department_name }}</text>
        <text class="ml-1">{{ props.model?.create_time }} 创建</text>
      </div>
    </div>
  </div>
  <el-dialog
    v-model="state.showEdit"
    title="编辑供应商"
    class="c-el-dialog"
    width="50%"
    :before-close="
      () => {
        state.showEdit = false;
      }
    "
  >
    <c_info
      :id="props.model?.id"
      @close="
        (refresh) => {
          state.showEdit = false;
          if (refresh) onLoad();
        }
      "
    />
  </el-dialog>
</template>

<script>
import { onMounted, reactive } from "vue";
import c_info from "../Info.vue";

export default {
  props: {
    model: Object,
  },
  components: {
    c_info,
  },
  setup(props, { emit }) {
    const state = reactive({});
    onMounted(() => {});

    const onLoad = () => {
      emit("load");
    };
    return { state, props, onLoad };
  },
};
</script>

<style lang="less" scoped></style>
